"use client"

import { SelectCategory } from "@/components/select-category"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"

export type VideoCategoryLayoutProps = {
  category:
    | {
        categoryId: string
        categoryName?: string
        slug?: string
        playlistUrl?: string
      }
    | string
}

export const VideoCategoryLayout = {
  label: "Tamda Media | VideoCategoryLayout",
  fields: {
    category: {
      type: "custom",
      label: "Category",
      render: props => <SelectCategory {...props} />,
    },
  },
  defaultProps: {
    category: "",
  },
  ...RenderConfig,
} as ComponentConfig<VideoCategoryLayoutProps>
